import { render, staticRenderFns } from "./short_video.vue?vue&type=template&id=0b589484&scoped=true&"
import script from "./short_video.vue?vue&type=script&lang=ts&"
export * from "./short_video.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b589484",
  null
  
)

export default component.exports